import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function DeliveryBanner(props) {
  const config = useThemeConfig();
  const ThemedDeliveryBanner = config.components.DeliveryBanner;

  return <ThemedDeliveryBanner {...props} />;
}
